var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiSemantic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h256v256H0V0z",
    fill: "#34BDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.461 87.041c-13.516-7.842-25.514-14.009-41.21-13.737-8.98.156-16.69 5.037-18.311 13.97-1.509 8.311 5.879 12.921 13.565 15.751 12.747 4.694 23.844 9.65 36.369 14.869 22.769 9.489 34.444 24.856 33.064 44.573-1.756 25.087-16.854 43.08-40.849 49.012-31.354 7.752-61.801-4.056-87.526-20.54 6.493-9.891 14.026-16.643 20.48-26.474 14.862 6.326 26.538 14.874 42.086 16.207 10.963.94 23.385.417 25.848-12.46 2.22-11.612-7.886-17.837-17.743-21.314-11.735-4.139-23.448-9.202-34.956-13.902-21.273-8.689-29.929-25.684-28.472-45.705 0-11.739 9.74-35.466 33.621-42.846 36.692-11.34 56.908.272 83.515 17.371-7.067 9.346-12.5 15.991-19.481 25.225",
    fill: "#FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiSemantic);
export default __webpack_public_path__ + "static/media/uiSemantic.2ff89935.svg";
export { ForwardRef as ReactComponent };